export default __webpack_public_path__ + "static/media/explore-icon.3ba0fe30.svg";